const FACEBOOK_SERVICE = 'facebook';
const TWITTER_SERVICE = 'twitter';
const DOWNLOAD_SERVICE = 'download';

class SocialServices {
	constructor({ onSetProgress, config, httpClient } = {}) {
		this.onSetProgress = onSetProgress;
		this.config = config;
		this.httpClient = httpClient;
	}

	openServiceWindow(url) {
		const width = window.screen.availWidth >= 580 ? '580' : '' + window.screen.availWidth,
			height = window.screen.availHeight >= 400 ? '400' : '' + window.screen.availHeight,
			top = window.screen.availHeight - height > 0 ? (window.screen.availHeight - height) / 3 : 0,
			left = window.screen.availWidth - width > 0 ? (window.screen.availWidth - width) / 2 : 0,
			options =
				'height=' +
				height +
				',width=' +
				width +
				',top=' +
				top +
				',left=' +
				left +
				',toolbar=0,location=0,menubar=0,directories=0,scrollbars=0';

		if (this.shareWindow) {
			this.shareWindow.close();
		}

		this.shareWindow = window.open(url, 'socialwindow', options);
		if (this.shareWindow === null || typeof this.shareWindow === 'undefined') {
			window.alert('Please disable your pop-up blocker and share again.');
		}
		//store.dispatch(asyncActionCreators.createSetProgressAction(false));
		if (this.onSetProgress) {
			this.onSetProgress(false);
		}
	}

	destroy() {
		this.onSetProgress = null;
		this.config = null;
	}

	shareFacebook(fbId, image, text, folder, redirectId) {
		const share = (imgURL, imgId) => {
			const serviceWindowURL = (() => {
				return (
					`https://www.facebook.com/dialog/feed?app_id=${fbId}` +
					`&display=popup&picture=${window.escape(imgURL)}` +
					`&caption=${window.escape(text)}` +
					`&link=https://apps.interactiveone.com/meme/share/${folder}/${imgId}/${redirectId}`
				);
			})();
			this.openServiceWindow(serviceWindowURL);
		};

		if (image) {
			this.httpClient
				.postToEndpoint('memepost', { text: folder, image: image })
				.then(response => {
					if (
						response.status === 200 &&
						response.data &&
						response.data.status === 'success' &&
						response.data.url.length > 0
					) {
						try {
							share(response.data.url, response.data.id);
						} catch (err) {
							console.error('(***) Error parsing response data, err:', err);
							//store.dispatch(asyncActionCreators.createSetProgressAction(false));
							if (this.onSetProgress) {
								this.onSetProgress(false);
							}
						}
					} else {
						console.error('Error fetching server data, response:', response);
						//store.dispatch(asyncActionCreators.createSetProgressAction(false));
						if (this.onSetProgress) {
							this.onSetProgress(false);
						}
					}
				})
				.catch(error => {
					console.error('Error fetching server data:', error);
					//store.dispatch(asyncActionCreators.createSetProgressAction(false));
					if (this.onSetProgress) {
						this.onSetProgress(false);
					}
				});
		} else {
			share('', '');
		}
	}

	shareFBMainPage() {
		const serviceWindowURL = (() => {
			return (
				`https://www.facebook.com/dialog/feed?app_id=${this.config.facebookAppId}&display=popup` +
				'&link=http://womentoknow2017.hellobeautiful.com'
			);
		})();
		this.openServiceWindow(serviceWindowURL);
	}

	shareTwitter(text) {
		var url =
			'https://twitter.com/intent/tweet?url=' +
			window.escape(window.location.href) +
			'&text=' +
			window.escape(text);
		this.openServiceWindow(url);
	}

	socialClick({ message, service, image }) {
		//const { meme } = store.getState();
		const text = this.config.shareText + message; //meme.text;
		switch (service) {
			case FACEBOOK_SERVICE: {
				setTimeout(() => {
					//store.dispatch(asyncActionCreators.createSetProgressAction(true));
					if (this.onSetProgress) {
						this.onSetProgress(true);
					}
					const folder = this.config.memeAppBucket;
					const fbId = this.config.facebookAppId;
					const redirectId = this.config.memeRedirectId;
					this.shareFacebook(fbId, image, text, folder, redirectId);
				}, 200);

				break;
			}
			case TWITTER_SERVICE:
				this.shareTwitter(text);

				break;
			case DOWNLOAD_SERVICE:
				break;
			default:
				break;
		}
	}
}

export default SocialServices;
export { DOWNLOAD_SERVICE, FACEBOOK_SERVICE, TWITTER_SERVICE };



// WEBPACK FOOTER //
// ./src/js/utils/socialServices.js